/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface ActivateCollectorLicense201Response
 */
export interface ActivateCollectorLicense201Response {
    /**
     * 
     */
    message: string;
}

/**
 * Check if a given object implements the ActivateCollectorLicense201Response interface.
 */
export function instanceOfActivateCollectorLicense201Response(value: object): value is ActivateCollectorLicense201Response {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ActivateCollectorLicense201ResponseFromJSON(json: any): ActivateCollectorLicense201Response {
    return ActivateCollectorLicense201ResponseFromJSONTyped(json, false);
}

export function ActivateCollectorLicense201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateCollectorLicense201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function ActivateCollectorLicense201ResponseToJSON(json: any): ActivateCollectorLicense201Response {
    return ActivateCollectorLicense201ResponseToJSONTyped(json, false);
}

export function ActivateCollectorLicense201ResponseToJSONTyped(value?: ActivateCollectorLicense201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

